class PrefillCtrl {
  constructor(TemplateService, SchemaService) {
    'ngInject';
    this.ss = SchemaService;
    this.ts = TemplateService;
    this.initNewPrefill();
    this.columns = [
      {
        'key': 'reference',
        'header': "Target Table",
        'style': { 'text-align': 'center' },
        'format': (val) => val.name
      },
      {
        'key': 'targetField',
        'header': "Target Field",
        'style': { 'text-align': 'center' },
        'format': val => val.label
      },
      {
        'key': 'sourceField',
        'header': 'Source Field',
        'style': { 'text-align': 'center' },
        'format': (val, index) => val.label
      },
      {
        'key': 'reference',
        'header': 'Remove',
        'style': { 'text-align': 'center' },
        'format': () => `<i class="fa fa-trash text-muted"></i>`,
        'onClick': (val, record, index) => this.prefills.splice(index, 1)
      }
    ];
  }

  initNewPrefill() {
    this.targetFields = {};
    this.newPrefill = {};
    this.showForm = false;
    this.syncDraftIncomplete();
  }

  addNewPrefill(prefill) {
    this.prefills.push(prefill);
    this.initNewPrefill();
  }

  isDraftPrefillEmpty() {
    const { reference, targetField, sourceField } = this.newPrefill || {};
    return !reference && !targetField && !sourceField;
  }

  hasIncompleteDraft() {
    if (this.showForm) return true;
    return !this.isDraftPrefillEmpty();
  }

  syncDraftIncomplete() {
    if (this.draftIncomplete === undefined) return;
    this.draftIncomplete = this.hasIncompleteDraft();
  }

  async refSelected(tableId) {
    try {
      this.targetFields = {}; // Clear while 'awaiting'
      const res = await this.ss.getSchema(this.ts.template, tableId);
      this.targetFields = res.fields;
    } catch (error) {
      this.handleMessage({rawMessage: {error, when: "Loading Target Table Information"}});
    }
  }
  
  showNewPrefill = () => {
    this.showForm = true;
    this.syncDraftIncomplete();
  };

  filterTargetFields = () => {
    const { prefills, 'newPrefill': { reference = {} } } = this;
    return (field) => {
      return field.isPrefillTarget && !prefills.some(p => {
        return p.reference.id === reference.id && p.targetField.id === field.id;
      })
    };
  }

  referenceEligibleFilter = (ref) => {
    const ids = this.eligibleReferenceIds;
    if (!ids || !ids.length) return true;
    return ids.includes(ref.id);
  };
  
}

export default {
  bindings: {
    newField: "=",
    prefills: "=",
    showForm: '=',
    sourceFields: '<',
    eligibleReferenceIds: '<',
    highlightDraft: '<',
    draftIncomplete: '=?',
    handleMessage: "&",
  },
  templateUrl: "form-builder/build-wizard/prefill/prefill.component.html",
  controller: PrefillCtrl
};
